import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'
import { isVoc } from '../util/isVocUtil'

const sentencesResolver: FieldResolver = (metadata: Metadata) => {
  const widgetType = metadata.getWidgetType()
  if (
    widgetType === WidgetType.SOCIAL_WEB_POPULAR_POSTS ||
    widgetType === WidgetType.SOCIAL_WEB_POPULAR_LINKS ||
    widgetType === WidgetType.AUDIENCE_POPULAR_LINKS
  ) {
    if (!isVoc(metadata)) {
      return {} as StreamData
    }
  }

  return { sentences: metadata.getSentences() } as StreamData
}

export default sentencesResolver
